module.exports = __webpack_public_path__ + "img/1-8.7dfe7833.png";